import React, { useLayoutEffect, useRef, useState } from 'react';
import './switcher.css';
import { trackPlansPageEvent } from '@/data/utils/plansPageAnalytics';

const PlanSwitcher = ({ billingCycle = 'yearly', onChange }) => {
	const monthlyRef = useRef(null);
	const yearlyRef = useRef(null);
	const containerRef = useRef(null);
	const [bgStyle, setBgStyle] = useState({ width: 0, left: 0 });

	const updatePosition = () => {
		if (!monthlyRef.current || !yearlyRef.current) return;

		const activeRef =
			billingCycle === 'yearly'
				? yearlyRef.current
				: monthlyRef.current;

		setBgStyle({
			width: activeRef.offsetWidth,
			left: activeRef.offsetLeft
		});
	};

	useLayoutEffect(() => {
		updatePosition();

		if (document.fonts) {
			document.fonts.ready.then(updatePosition);
		}

		window.addEventListener('resize', updatePosition);

		return () => {
			window.removeEventListener('resize', updatePosition);
		};
	}, [billingCycle]);

	const handleCycleChange = (cycle) => {
		trackPlansPageEvent({
			eventName: 'onboarding_v2_billing_cycle_switched',
			billingCycle: cycle,
			source: 'onboarding_v2_plan_switcher',
			meta: { previousCycle: billingCycle }
		});
		onChange?.(cycle);
	};

	return (
		<div ref={containerRef} className="onboarding-plan-switcher">
			<div
				className="onboarding-plan-switcher__active"
				style={bgStyle}
			/>
			<button
				type="button"
				ref={monthlyRef}
				className={`onboarding-plan-switcher__label ${
					billingCycle === 'monthly' ? 'is-active' : ''
				}`}
				onClick={() => handleCycleChange('monthly')}
			>
				Monthly
			</button>

			<button
				type="button"
				ref={yearlyRef}
				className={`onboarding-plan-switcher__label ${
					billingCycle === 'yearly' ? 'is-active' : ''
				}`}
				onClick={() => handleCycleChange('yearly')}
			>
				Yearly
				<span className="onboarding-plan-switcher__discount">
					Up to 45% OFF
				</span>
			</button>
		</div>
	);
};

export default PlanSwitcher;
